import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownAZ, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../../common/pallette/colors';
import './styles.css';

const SortBox = (props: { label: any; options: any; handleClick?: any }) => {
  const { options, handleClick } = props;
  const [value, setValue] = useState(options[0].name);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (optName: string) => {
    setValue(optName);
    handleClick && handleClick(optName);
    handleClose();
  };

  return (
    <Tooltip title={`Sort: ${value}`} arrow placement="top">
      <Box className="sortBoxWrapper">
        <IconButton
          size="small"
          onClick={handleOpen}
          className="sortIconBtn"
          aria-haspopup="true"
        >
          <FontAwesomeIcon icon={faArrowDownAZ} className="sortIconMain" />
          <FontAwesomeIcon icon={faChevronDown} className="sortIconCaret" />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{ sx: { minWidth: 140, mt: '4px', boxShadow: '0 4px 16px rgba(0,0,0,0.12)' } }}
        >
          {options.map((option: any) => (
            <MenuItem
              key={option.name}
              value={option.name}
              selected={option.name === value}
              onClick={() => handleSelect(option.name)}
              className="sortBoxmenuItem"
              sx={{
                fontSize: '12px',
                '&.Mui-selected': {
                  backgroundColor: `${colors.blue.navy}10`,
                  color: colors.blue.navy,
                  fontWeight: 600,
                },
                '&.Mui-selected:hover': {
                  backgroundColor: `${colors.blue.navy}18`,
                },
              }}
            >
              {option.name}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </Tooltip>
  );
};

export default SortBox;
